module.exports = __webpack_public_path__ + "img/proship-logo-sm.8675c969.png";